import { render, staticRenderFns } from "./model_5.vue?vue&type=template&id=20007c5c&scoped=true"
import script from "./model_5.vue?vue&type=script&lang=js"
export * from "./model_5.vue?vue&type=script&lang=js"
import style0 from "./model_5.vue?vue&type=style&index=0&id=20007c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20007c5c",
  null
  
)

export default component.exports